module.exports = __webpack_public_path__ + "static/img/sec-bg.bbc5b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sec-bg.png
// module id = 840d
// module chunks = 1